import { forwardRef, type Ref, type SVGProps } from "react";
const IconParkingOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M28 4v24H4V4zm0-2H4a2 2 0 0 0-2 2v24a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2"
    />
    <path
      fill="currentColor"
      d="M17.56 8H11v16h4v-5h2.52A5.13 5.13 0 0 0 23 13.53 5.18 5.18 0 0 0 17.56 8m-1 8H15v-5h1.94a2.29 2.29 0 0 1 2.5 2.5c0 1.82-1.12 2.5-2.93 2.5Z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconParkingOutlineSVG);
ForwardRef.displayName = "IconParkingOutline";
export { ForwardRef as IconParkingOutline };
